import { render, staticRenderFns } from "./SectionBoard.vue?vue&type=template&id=299397b6&scoped=true&"
import script from "./SectionBoard.vue?vue&type=script&lang=js&"
export * from "./SectionBoard.vue?vue&type=script&lang=js&"
import style0 from "./SectionBoard.vue?vue&type=style&index=0&id=299397b6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299397b6",
  null
  
)

export default component.exports